// Offline icon registration (same rationale as web/app: no runtime
// fetches, CSP stays tight).
import { addCollection } from '@iconify/react'
import gravityUI from '@iconify-json/gravity-ui/icons.json'

addCollection(gravityUI)
